/* eslint-disable max-classes-per-file,no-use-before-define,lines-between-class-members */
class Watch {
  observed: Observed;
  name: string;
  callbacks: ((v: any)=>void)[];

  constructor (name: string, observed: Observed) {
    this.name = name;
    this.observed = observed;
    this.observed.add(this);
    this.callbacks = [];
  }

  update (val: any) {
    this.callbacks.forEach((callback) => {
      Reflect.apply(callback, this, [val,]);
    });
  }

  add (callback: (v: any)=>void) {
    this.callbacks.push(callback);
  }
}

class Observed {
  state: any;
  watchers: Watch[];

  constructor () {
    this.watchers = [];
    this.state = null;
  }

  add (watcher: Watch) {
    this.watchers.push(watcher);
  }

  setState (val: any) {
    this.state = val;
    this.notify();
  }

  notify () {
    this.watchers.forEach((watcher) => {
      watcher.update(this.state);
    });
  }
}

export {
  Watch,
  Observed,
};
